angular.module('graph').controller('ph-user', [
    '$scope', '$window', 'ph-route-params-service', 'ph-core', '$rootScope', 'ph-broadcast',
    function ($scope, $window, $routeParams, $core, $root, $broadcast) {
        $scope.user = {
            'firstname': null,
            'lastname': null,
            'email': null,
            'password': null,
            'repassword': null,
            'fb_token': null
        };

        $scope.form = {
            'join': {},
            'login': {}
        };

        var queries = [
            'response_type',
            'browser',
            'redirect'
        ];

        $scope.$query = $core.$uri.$query.new();

        $scope.query = function ($key, $value) {
            if ($key && $value) {
                $scope.$query.set($key, $value);
                return;
            }

            queries.forEach(function (key) {
                var $query = $routeParams.$getQueryByName(key);

                if ($query !== null && $query !== '')
                    $scope.$query.set(key, $query);
            });
        };

        $scope.submitted = false;

        $scope.join = function ($user) {
            if ($scope.form.join.$valid === false)
                return;

            if ($scope.submitted === false) {

                $scope.submitted = true;

                $core.post('/xhr/join', $user)
                    .then(function ($response) {
                        if ($response.data.state === 12) {
                            redirect('/verify');
                        } else if ($response.data.state === 0) {
                            var $redirect = $routeParams.$getQueryByName('redirect');
                            if ($redirect === null || $redirect === '') {
                                redirect('/settings');
                            } else
                                $window.location.href = $redirect;
                        } else if ($response.data.state === 11) {
                            if (typeof $response.data.error === 'object') {
                                var $error = '';

                                for (var input in $response.data.error) {
                                    var err = $response.data.error[input];
                                    $error  = $error.concat(
                                        err
                                    );
                                }
                                $root.$broadcast('ph-modal-show', $error);
                            } else
                                $root.$broadcast('ph-modal-show', $response.data.error);

                            $scope.submitted = false;
                        }
                    });
            }
        };

        $scope.login = function ($user) {
            if ($scope.form.login.$valid === false)
                return;

            if ($scope.submitted === false) {

                $scope.submitted = true;

                $core.post('/xhr/login', $user)
                    .then(function ($response) {
                        if ($response.data.state === 12) {
                            redirect('/verify');
                        } else if ($response.data.state === 0) {
                            var $redirect = $routeParams.$getQueryByName('redirect');
                            if ($redirect === null || $redirect === '') {
                                redirect('/login');
                            } else
                                $window.location.href = $redirect;
                        } else if ($response.data.state === 11) {
                            if (typeof $response.data.error === 'object') {
                                var $error = '';

                                for (var input in $response.data.error) {
                                    var err = $response.data.error[input];
                                    $error  = $error.concat(
                                        err
                                    );
                                }
                                $root.$broadcast('ph-modal-show', $error);
                            } else
                                $root.$broadcast('ph-modal-show', $response.data.error);

                            $scope.submitted = false;
                        }
                    });
            }
        };

        $scope.query();

        function redirect(route, $query) {
            var $redirect = route;
            if (!$query || $query === false)
                $redirect += '?' + $scope.$query.str();

            $window.location.href = $redirect;
        }
    }
]);

angular.module('graph').controller('ph-user-read', [
    '$scope', 'ph-core', '$rootScope', 'ph-broadcast',
    function ($scope, $core, $root, $broadcast) {
        $scope.profile = {};
        var $cuid      = $core.random();

        $scope.upload = function ($type) {
            $type = 'picture';
            $core.post('/xhr/me/' + $type, {
                name: $scope[$type].filename,
                picture: 'data:' + $scope[$type].filetype + ';base64,' + $scope[$type].base64
            }).then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.profile[$type] = $response.data.data;
                }
            });
        };

        $scope.upload = {
            "picture": function () {
                if ($scope.form.upload.picture.$valid === true) {
                    $scope.upload.photo('picture');
                }
            },
            "cover": function () {
                if ($scope.form.upload.cover.$valid === true) {
                    $scope.upload.photo('cover');
                }
            },
            "photo": function ($type) {
                $core.post('/xhr/me/' + $type, {
                    name: $scope[$type].name,
                    photo: $scope[$type].base
                }).then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.profile[$type] = $response.data.data;
                    } else {
                        $root.$broadcast('ph-modal-show', $response.data.data.photo);
                    }
                });
            }
        };

        $scope.listen = function () {
            $broadcast.emit('join:user', [
                $scope.profile.id
            ]);
        };

        $scope.request = function () {
            $core.post('/xhr/' + $scope.profile.id + '/friends', null, $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.request();
            });
        };

        $scope.accept = function () {
            $core.post('/xhr/' + $scope.profile.id + '/friend/request', null, $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.accept();
            });
        };

        $scope.reject = function () {
            $core.delete('/xhr/' + $scope.profile.id + '/friend/request', $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.reject();
            });
        };

        $scope.unfriend = function () {
            $core.delete('/xhr/' + $scope.profile.id + '/friends', $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.unfriend();
            });
        };

        $scope.block = function () {
            $core.post('/xhr/' + $scope.profile.id + '/blacklist', null, $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.block();
            });
        };

        $scope.unblock = function () {
            $core.delete('/xhr/' + $scope.profile.id + '/blacklist', $cuid).then(function ($request) {
                if ($request.data.state === 0)
                    $scope.$event.unblock();
            });
        };

        $scope.$event = {
            "request": function ($data) {
                $scope.profile.is.pending    = true;
                $scope.profile.is.not_friend = false;
            },
            "accept": function ($data) {
                $scope.profile.is.friend    = true;
                $scope.profile.is.requested = false;
                // ++$scope.profile.friends;
            },
            "reject": function ($integration) {
                $scope.profile.is.not_friend = true;
                $scope.profile.is.requested  = false;
            },
            "unfriend": function ($integration) {
                $scope.profile.is.friend     = false;
                $scope.profile.is.not_friend = true;
                // --$scope.profile.friends;
            },
            "block": function ($integration) {
                $scope.profile.is.friend  = false;
                $scope.profile.is.blocked = true;
            },
            "unblock": function ($integration) {
                $scope.profile.is.not_friend = true;
                $scope.profile.is.blocked    = false;
            },
            "$to": {
                "request": function ($data) {
                    $scope.profile.is.requested  = true;
                    $scope.profile.is.not_friend = false;
                },
                "accept": function ($data) {
                    $scope.profile.is.friend  = true;
                    $scope.profile.is.pending = false;
                    // ++$scope.profile.friends;
                },
                "reject": function ($integration) {
                    $scope.profile.is.not_friend = true;
                    $scope.profile.is.pending    = false;
                },
                "unfriend": function ($integration) {
                    $scope.profile.is.friend     = false;
                    $scope.profile.is.not_friend = true;
                },
                "block": function ($integration) {
                    $scope.profile.is.friend     = false;
                    $scope.profile.is.not_friend = true;
                    // --$scope.profile.friends;

                    location.reload();
                },
                "unblock": function ($integration) {
                    //
                }
            }
        };

        /**
         *
         */
        $broadcast.on('user:friend:find', function ($data, $guid) {
            ++$scope.profile.friends;
        });

        /**
         *
         */
        $broadcast.on('user:friend:lost', function ($data, $guid) {
            --$scope.profile.friends;
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.request();
        });

        /**
         *
         */
        $broadcast.on('user:term:request', function ($data, $guid) {
            $scope.$event.$to.request();
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:accept', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.accept();
        });

        /**
         *
         */
        $broadcast.on('user:term:request:accept', function ($data, $guid) {
            $scope.$event.$to.accept();
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:reject', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.reject();
        });

        /**
         *
         */
        $broadcast.on('user:term:request:reject', function ($data, $guid) {
            $scope.$event.$to.reject();
        });

        /**
         *
         */
        $broadcast.on('me:user:term:unfriend', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.unfriend();
        });

        /**
         *
         */
        $broadcast.on('user:term:unfriend', function ($data, $guid) {
            $scope.$event.$to.unfriend();
        });

        /**
         *
         */
        $broadcast.on('me:user:term:block', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.block();
        });

        /**
         *
         */
        $broadcast.on('user:term:block', function ($data, $guid) {
            $scope.$event.$to.block();
        });

        /**
         *
         */
        $broadcast.on('me:user:term:unblock', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.unblock();
        });

        /**
         *
         */
        $broadcast.on('user:term:unblock', function ($data, $guid) {
            $scope.$event.$to.unblock();
        });
    }
]);

angular.module('graph').controller('ph-user-read-timeline-tab', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service',
    function ($scope, $core, $root, $phtouch) {
        $scope.posts = [];

        $scope.$page = 0;
        $scope.$let  = 0;
        $scope.$pagc = -1;
        var $module  = 'ph-user-read-timeline-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.find();
            });
        });

        $scope.find = function () {
            if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
                return;

            var $query = $core.$uri.$query.new({
                page: +(++$scope.$page),
                let: $scope.$let
            }).str();

            $core.get('/xhr/' + $scope.$parent.profile.id + '/feed?' + $query)
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.$pagc = $response.data.pages;

                        $scope.posts = $scope.posts.concat(
                            $response.data.data
                        );
                    }
                });
        };
    }
]);

angular.module('graph').controller('ph-user-settings', [
    '$scope', 'ph-core', '$rootScope', '$timeout', '$cookies',
    function ($scope, $core, $root, $timeout, $cookies) {
        $scope.profile = {};

        $scope.load = function () {
            $core.get('/xhr/settings').then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.profile = $response.data.data;
                    $root.$broadcast('ph-root-endorse-update', $scope.profile.id);
                }
            });
        };

        $scope.update = function () {
            $root.screen_lock = 1;

            $timeout(function () {
                $core.post('/xhr/settings', $scope.profile)
                    .then(function ($response) {
                        $scope.error = {};

                        $root.screen_lock = 0;

                        if ($response.data.state === 6) {
                            $scope.error = $response.data.data;
                        } else if ($response.data.state === 0) {
                            // TY-1290 using browser timezone instead of user's stored timezone
                            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                            $cookies.put(
                                '__gputz', timezone, {
                                    path    : '/',
                                    expires : new Date(2147483647 * 1000),
                                    secure  : location.protocol === 'https:',
                                }
                            );

                            $cookies.put(
                                '__gpuln', $scope.profile.locale, {
                                    path    : '/',
                                    expires : new Date(2147483647 * 1000),
                                    secure  : location.protocol === 'https:',
                                }
                            );
                        }

                        $root.$broadcast('ph-modal-show', $response.data.data.content);
                    });
            });
        };

        $scope.unlink = function ($url, $name) {
            $core.post($url, $scope.profile)
                .then(function ($response) {
                    $scope.profile[$name] = null;
                });
        };

        $scope.load();
    }
]);

angular.module('graph').controller('ph-user-read-information-tab', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service',
    function ($scope, $core, $root, $phtouch) {
        $scope.info = {};

        var $module = 'ph-user-read-information-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.find();
            });
        });

        $scope.find = function () {
            $core.get('/xhr/' + $scope.$parent.profile.id + '/info')
                .then(function ($response) {
                    $scope.info = $response.data.data;
                });
        };
    }
]);

angular.module('graph').controller('ph-user-read-friends-tab', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $core, $root, $phtouch, $broadcast) {
        $scope.friends = [];
        $scope.$page   = 0;
        $scope.$let    = 0;
        $scope.$pagc   = -1;

        var $module = 'ph-user-read-friends-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.find();
            });
        });

        $scope.find = function () {
            if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
                return;

            var $query = $core.$uri.$query.new({
                page: +(++$scope.$page),
                let: $scope.$let
            }).str();

            $core.get('/xhr/' + $scope.$parent.profile.id + '/friends?' + $query)
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.$pagc = $response.data.pages;

                        $scope.friends = $scope.friends.concat(
                            $response.data.data
                        );
                    }
                });
        };

        /**
         *
         */
        $broadcast.on('user:friend:find', function ($data, $guid) {
            if ($phtouch.$is($module)) {
                ++$scope.$let;
                $scope.friends.unshift($data.user);
            }
        });

        /**
         *
         */
        $broadcast.on('user:friend:lost', function ($data, $guid) {
            if ($phtouch.$is($module)) {
                $core.$array.rm($scope.friends, $data.user.id, function () {
                    --$scope.$let;
                });
            }
        });
    }
]);

angular.module('graph').controller('ph-drop-friend-requests', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $core, $root, $phtouch, $broadcast) {
        var $module = 'ph-drop-friend-requests';
        var $cuid   = $core.random();

        $scope.requests = [];
        $scope.$items   = 25;
        $scope.$let     = 0;
        $scope.$page    = 0;
        $scope.$pagc    = -1;

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.find();
            });
        });

        $scope.$event = {
            "request": function ($request) {
                $scope.requests.unshift($request);
                ++$scope.$let;
            },
            "accept": function ($request) {
                $core.$array.rm($scope.requests, $request.id, function () {
                    --$scope.$let;
                });
            },
            "reject": function ($request) {
                $core.$array.rm($scope.requests, $request.id, function () {
                    --$scope.$let;
                });
            }
        };

        $scope.find = function () {
            if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
                return;

            var $query = $core.$uri.$query.new({
                page: +(++$scope.$page),
                items: $scope.$items,
                let: $scope.$let
            }).str();

            $core.get('/xhr/me/friend/requests?' + $query)
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.$pagc = $response.data.pages;

                        $scope.requests = $scope.requests.concat(
                            $response.data.data
                        );
                    }
                });
        };

        $scope.accept = function ($request) {
            $core.post('/xhr/' + $request.id + '/friend/request', null, $cuid).then(function ($response) {
                if ($response.data.state === 0)
                    $scope.$event.accept($request);
            });
        };

        $scope.reject = function ($request) {
            $core.delete('/xhr/' + $request.id + '/friend/request', $cuid).then(function ($response) {
                if ($response.data.state === 0)
                    $scope.$event.reject($request);
            });
        };

        $broadcast.on('user:term:request', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.request($data.user);

            ++$scope.$parent.needread.friend;
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:accept', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.accept($data.entry);

            --$scope.$parent.needread.friend;
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:reject', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.reject($data.entry);

            --$scope.$parent.needread.friend;
        });
    }
]);

angular.module('graph').controller('ph-user-term-friend', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service', 'ph-broadcast', 'fxScrollFactory',
    function ($scope, $core, $root, $phtouch, $broadcast, $scroll) {
        $scope.friends = [];
        $scope.$items  = 25;
        $scope.$let    = 0;
        $scope.$page   = 0;
        $scope.$pagc   = -1;

        $scope.find = function (next) {
            if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
                return;

            var $query = $core.$uri.$query.new({
                page: +(++$scope.$page),
                items: $scope.$items,
                let: $scope.$let
            }).str();

            $core.get('/xhr/me/friends?' + $query)
                .then(function ($response) {
                    if ($response.data.state === 0 && $response.data.data.length > 0) {
                        $scope.$pagc = $response.data.pages;

                        $scope.friends = $scope.friends.concat(
                            $response.data.data
                        );

                        if (next) next();
                    }
                });
        };

        /**
         *
         */
        $broadcast.emit('join:user', [
            $root.user.id
        ]);

        /**
         *
         */
        $broadcast.on('user:friend:find', function ($data, $guid) {
            ++$scope.$let;
            $scope.friends.unshift($data.user);
        });

        /**
         *
         */
        $broadcast.on('user:friend:lost', function ($data, $guid) {
            $core.$array.rm($scope.friends, $data.user.id, function () {
                --$scope.$let;
            });
        });
    }
]);

angular.module('graph').controller('ph-user-term-friend-request', [
    '$scope', 'ph-core', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $core, $root, $phtouch, $broadcast) {
        var $cuid = $core.random();

        $scope.requests = [];
        $scope.$items   = 25;
        $scope.$let     = 0;
        $scope.$page    = 0;
        $scope.$pagc    = -1;

        $scope.$event = {
            "request": function ($request) {
                $scope.requests.unshift($request);
                ++$scope.$let;
            },
            "accept": function ($request) {
                $core.$array.rm($scope.requests, $request.id, function () {
                    --$scope.$let;
                });
            },
            "reject": function ($request) {
                $core.$array.rm($scope.requests, $request.id, function () {
                    --$scope.$let;
                });
            }
        };

        $scope.find = function () {
            if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
                return;

            var $query = $core.$uri.$query.new({
                page: +(++$scope.$page),
                items: $scope.$items,
                let: $scope.$let
            }).str();

            $core.get('/xhr/me/friend/requests?' + $query)
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.$pagc = $response.data.pages;

                        $scope.requests = $scope.requests.concat(
                            $response.data.data
                        );
                    }
                });
        };

        $scope.accept = function ($request) {
            $core.post('/xhr/' + $request.id + '/friend/request', null, $cuid).then(function ($response) {
                if ($response.data.state === 0)
                    $scope.$event.accept($request);
            });
        };

        $scope.reject = function ($request) {
            $core.delete('/xhr/' + $request.id + '/friend/request', $cuid).then(function ($response) {
                if ($response.data.state === 0)
                    $scope.$event.reject($request);
            });
        };

        $broadcast.on('user:term:request', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.request($data.user);
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:accept', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.accept($data.entry);
        });

        /**
         *
         */
        $broadcast.on('me:user:term:request:reject', function ($data, $guid) {
            if ($cuid !== $guid)
                $scope.$event.reject($data.entry);
        });
    }
]);
